var $3afa4fed88f1c3d4$exports = {};
$3afa4fed88f1c3d4$exports = {
    "info": `Info`,
    "negative": `Fejl`,
    "positive": `Fuldf\xf8rt`
};


export {$3afa4fed88f1c3d4$exports as default};
//# sourceMappingURL=da-DK.mjs.map
